<script setup lang="ts">
import BaseTabs from '@/components/BaseTabs.vue'
import EstimateDetails from '@/components/EstimateDetails.vue'
import EstimateSortTypes from '@/components/EstimateSortTypes.vue'
import EstimateSummary from '@/components/EstimateSummary.vue'
import { useDatabaseStore } from '@/stores/databaseStore'
import { computed, ref } from 'vue'

const props = defineProps<{
  estimateId: string
}>()

const databaseStore = useDatabaseStore()
const estimate = computed(() => databaseStore.estimates?.find((e) => e.id === props.estimateId))

const tabs = ['Documents', 'Estimate', 'Takeoff', 'Sort Types', 'Summary'] as const
const currentTab = ref<(typeof tabs)[number]>('Estimate')
</script>

<template>
  <div class="flex h-full w-full flex-col">
    <header class="flex w-full items-center justify-between bg-blue-300 p-4 text-xl font-bold">
      <div class="flex flex-col">
        <h1 class="text-xl font-bold">Estimate</h1>
        <small class="font-semibold text-gray-500">{{ estimate?.name }}</small>
      </div>
      <div class="flex gap-3">
        <div class="flex flex-nowrap text-sm">
          <span class="font-semibold text-gray-500">Total Estimate: </span>
          <span class="flex text-blue-500">$0.00</span>
        </div>
        <div class="flex flex-nowrap text-sm">
          <span class="font-semibold text-gray-500">Status: </span>
          <span class="flex text-blue-500">{{
            databaseStore.estimateStatus?.find((e) => e.id == estimate?.estimate_status_id)?.name
          }}</span>
        </div>
        <div class="flex flex-nowrap text-sm">
          <span class="font-semibold text-gray-500">Type: </span>
          <span class="flex text-blue-500">{{
            databaseStore.estimateTypes?.find((e) => e.id == estimate?.estimate_type_id)?.name
          }}</span>
        </div>
      </div>
    </header>
    <BaseTabs :tabs="tabs" v-model="currentTab">
      <EstimateDetails v-if="currentTab === 'Estimate'" :estimate-id="props.estimateId" />
      <EstimateSummary v-else-if="currentTab === 'Summary'" :estimate-id="props.estimateId" />
      <EstimateSortTypes v-else-if="currentTab === 'Sort Types'" :estimate-id="props.estimateId" />
    </BaseTabs>
  </div>
</template>
